import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: false
})
export class FilterPipe implements PipeTransform {
    transform(arrayData, searchItem) {
        console.log(arrayData, searchItem);
        
        // Check if arrayData or searchItem is falsy, return arrayData if so
        if (!arrayData || !searchItem) {
            return arrayData;
        }
    
        // Function to stringify and lowercase a value
        const stringifyAndLower = value => JSON.stringify(value).toLowerCase();
    
        // Array of properties to search in each item
        const searchProperties = [
            'payer_sap_code',
            'payer_name',
            'ship_to_sap_number',
            'ship_to_name',
            'name',
            'company_name',
            'list',
            'contract_number',
            'contract_name',
            'ship_tos_extra_data.address2', // Nested property
            'material_name',
            'material_description',
            'discount_voucher'
        ];
    
        // Filter arrayData based on searchItem and searchProperties
        return arrayData.filter(item => {
            // Check if any property contains the searchItem
            return searchProperties?.some(property => {
                const value = this.getProperty(item, property);
                return value && stringifyAndLower(value).includes(searchItem.toLowerCase());
            });
        });
    }
    
    // Helper function to get nested properties
    getProperty(object, path) {
        return path.split('.').reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, object);
    }
}
